import React from 'react'
import cx from 'classnames'
import Collapse from 'react-collapse'
import { useConnect } from 'sb-redux-hook'
import { FormattedMessage } from 'sb-react-intl'
import { snowplow, constants } from 'common/helpers'

import LinkWithIcon from 'components/ui/LinkWithIcon/LinkWithIcon'
import { AccordionItem, AccordionButton, AccordionPanel } from 'components/_new/ui/Accordion'

import s from './Section.scss'


const FooterMobileSectionSite = (props) => {
  const { title, nav, activeSection, toggleSection } = props
  const isOpened = activeSection === title

  const { userLoggedIn } = useConnect({
    userLoggedIn: 'models.me.isLoggedIn',
  })

  const sectionClassName = cx(s.section, {
    [s.opened]: isOpened,
  })

  return (
    <AccordionItem>
      {
        ({ isOpen }) => (
          <div className={sectionClassName}>
            <AccordionButton
              className={s.title}
              onClick={() => toggleSection(title)}
            >
              <FormattedMessage {...title} />
              <div className={s.arrow} />
            </AccordionButton>
            <AccordionPanel>
              <div className={s.nav}>
                {
                  nav.map(({ title, icon, to, toOLD, redirect, onClick }, index) => (
                    <LinkWithIcon
                      key={index}
                      className={s.navItem}
                      rel="nofollow"
                      tabIndex={isOpen ? '0' : '-1'}
                      customColor
                      onClick={(event) => {
                        snowplow.track(constants.snowplowEvents.footerLinkClick, {
                          title: typeof title === 'object' ? title.en : title,
                          userLoggedIn: userLoggedIn ? 'yes' : 'no',
                          link: to || toOLD || redirect,
                        })

                        if (typeof onClick === 'function') {
                          onClick(event)
                        }
                      }}
                      {...{ title, icon, to, toOLD, redirect }}
                    />
                  ))
                }
              </div>
            </AccordionPanel>
          </div>
        )
      }
    </AccordionItem>
  )
}

const FooterMobileSection = ({ title, nav, activeSection, toggleSection, isLandings }) => {
  const isOpened = activeSection === title

  const sectionClassName = cx(s.section, {
    [s.opened]: isOpened,
  })

  if (isLandings) {
    return (
      <div className={sectionClassName}>
        <div
          className={cx(s.title, 'footerSectionTitle')} // footerSectionTitle required for landings scripts click to open Collapse
          onClick={() => toggleSection(title)}
        >
          <FormattedMessage {...title} />
          <div className={s.arrow} />
        </div>
        <Collapse className="footerSection" isOpened={isOpened}>
          <div className={s.nav}>
            {
              nav.map(({ title, icon, to, toOLD, redirect }, index) => (
                <LinkWithIcon
                  key={index}
                  className={s.navItem}
                  rel="nofollow"
                  customColor
                  {...{ title, icon, to, toOLD, redirect }}
                />
              ))
            }
          </div>
        </Collapse>
      </div>
    )
  }

  return (
    <FooterMobileSectionSite {...{ title, nav, activeSection, toggleSection, isLandings }} />
  )
}


export default FooterMobileSection
